import { ONE_BUSINESS_DAY, ONE_MONTH, ONE_WEEK, SIX_MONTHS, THREE_BUSINESS_DAYS, THREE_MONTHS, TODAY, TWO_BUSINESS_DAYS, TWO_WEEKS } from 'task-forms-lib/constants/RelativeDates';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import once from 'transmute/once';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { View } from 'foundations-components/components/View';
import { Select } from 'foundations-components/transitional/components/Select';
import { updateDefaultDueDatePresetSetting, updateDefaultDueTimeSetting } from '../../reducers/stagedSettingsReducer';
import { defaultDueDatePresetSelector, defaultDueTimeSelector } from '../../selectors/SettingsSelectors';
import { trackDueDatePresetSettingChanged, trackDueTimeSettingChanged } from '../../usage/tracker';
import { Flex } from 'foundations-components/components/Flex';
import { TimePicker } from 'foundations-components/transitional/components/TimePicker';

// We exclude the TOMORROW preset from the list in favor of 1 business day.
// They are only different on fridays and saturdays, and the "Tomorrow" option
// existing alongside 1 business day on those days is really more of an
// emergency thing. Hence, TOMORROW is not relevant for task defaults.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const dueDatePresets = [TODAY, ONE_BUSINESS_DAY, TWO_BUSINESS_DAYS, THREE_BUSINESS_DAYS, ONE_WEEK, TWO_WEEKS, ONE_MONTH, THREE_MONTHS, SIX_MONTHS];
const getDueDateOptions = once(() => dueDatePresets.map(preset => ({
  value: preset,
  text: I18n.text(`CrmSettingsTaskReminders.defaults.dueDatePresets.${preset}`)
})));
export default function TimestampSettings() {
  const dispatch = useDispatch();
  const dueDatePreset = useSelector(defaultDueDatePresetSelector);
  const dueTimePreset = useSelector(defaultDueTimeSelector);
  const handleDueDatePresetChange = useCallback(evt => {
    dispatch(updateDefaultDueDatePresetSetting(evt.target.value));
    trackDueDatePresetSettingChanged(evt.target.value);
  }, [dispatch]);
  const handleDueTimeChange = useCallback(evt => {
    dispatch(updateDefaultDueTimeSetting(evt.currentTarget.value));
    trackDueTimeSettingChanged(evt.currentTarget.value);
  }, [dispatch]);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "baseline",
    children: [/*#__PURE__*/_jsx(View, {
      inlineSize: "300px",
      marginBlockStart: "0",
      marginInlineEnd: "200",
      children: /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CrmSettingsTaskReminders.defaults.dueDate"
        }),
        children: /*#__PURE__*/_jsx(Select, {
          "data-test-id": "CrmSettingsTaskReminders.defaults.dueDate.select",
          searchable: false,
          options: getDueDateOptions(),
          value: dueDatePreset,
          defaultValue: THREE_BUSINESS_DAYS,
          onChange: handleDueDatePresetChange
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      inlineSize: "300px",
      marginBlockStart: "0",
      children: /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CrmSettingsTaskReminders.defaults.dueTime"
        }),
        children: /*#__PURE__*/_jsx(TimePicker, {
          "data-test-id": "CrmSettingsTaskReminders.defaults.dueTime.select",
          clearable: false,
          interval: 15,
          value: dueTimePreset,
          defaultValue: 60 * 8,
          onChange: handleDueTimeChange
        })
      })
    })]
  });
}